import { z } from 'zod';
export const ScheduledSessionSchema = z.object({
    id: z.uuid(),
    startsAt: z.int().positive(),
    name: z.string().min(1).max(68),
    streamId: z.string(),
    broadcasterPrivateKey: z.string(),
    broadcasterUserId: z.string().length(68),
    aesKey: z.string().length(64),
});
export function validateScheduledSession(session) {
    const result = ScheduledSessionSchema.safeParse(session);
    return result.success ? [] : result.error.issues;
}
export function generateSessionId() {
    try {
        return crypto.randomUUID();
    }
    catch (_) { }
    // This is a fallback for browsers that don't support crypto.randomUUID()
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
